module.exports = __webpack_public_path__ + "static/media/podcasts-hero.69dffb21.svg";